export enum PositionEnum {
    forward = 'útočník',
    defence = 'obránce',
    goalie = 'brankář'
  }
